﻿// About Us — Collection Page Quick-Add (2026-06-21)
// Adds "Quick Add" buttons on collection page product cards.
// Single-variant: adds directly. Multi-variant: shows an inline size picker.
// Targets: /collections/* — all collection pages.
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (!/^\/collections\//.test(location.pathname)) return;
  if (window.__auCollectionQuickAddLoaded) return;
  window.__auCollectionQuickAddLoaded = true;

  var BRAND_NAVY = '#131936';
  var BRAND_MILK = '#F4F1EA';
  var FONT_BODY = "'Raleway', 'Helvetica Neue', sans-serif";

  // ── Styles ────────────────────────────────────────────────────────────────
  var style = document.createElement('style');
  style.textContent = [
    '.au-qa-wrap{position:relative;margin-top:8px;}',
    '.au-qa-btn{',
      'display:block;width:100%;padding:10px 16px;',
      'background:' + BRAND_NAVY + ';color:' + BRAND_MILK + ';',
      'font-family:' + FONT_BODY + ';font-size:12px;font-weight:600;',
      'letter-spacing:0.08em;text-transform:uppercase;text-align:center;',
      'border:none;cursor:pointer;transition:opacity .2s;line-height:1;',
    '}',
    '.au-qa-btn:hover{opacity:0.85;}',
    '.au-qa-btn:disabled{opacity:0.5;cursor:not-allowed;}',
    '.au-qa-overlay{',
      'position:absolute;bottom:calc(100% + 4px);left:0;right:0;',
      'background:' + BRAND_MILK + ';border:1px solid rgba(19,25,54,0.2);',
      'padding:12px;z-index:20;display:none;box-shadow:0 4px 16px rgba(19,25,54,0.12);',
    '}',
    '.au-qa-overlay.is-open{display:block;}',
    '.au-qa-overlay-title{',
      'font-family:' + FONT_BODY + ';font-size:10px;font-weight:700;',
      'color:rgba(19,25,54,0.52);letter-spacing:0.08em;text-transform:uppercase;',
      'margin:0 0 8px;',
    '}',
    '.au-qa-sizes{display:flex;flex-wrap:wrap;gap:5px;margin-bottom:10px;}',
    '.au-qa-size{',
      'padding:5px 9px;border:1px solid rgba(19,25,54,0.25);',
      'background:transparent;cursor:pointer;',
      'font-family:' + FONT_BODY + ';font-size:11px;color:' + BRAND_NAVY + ';',
      'transition:all .15s;line-height:1;',
    '}',
    '.au-qa-size:hover:not(:disabled),.au-qa-size.au-selected{',
      'background:' + BRAND_NAVY + ';color:' + BRAND_MILK + ';border-color:' + BRAND_NAVY + ';',
    '}',
    '.au-qa-size:disabled{opacity:0.32;cursor:not-allowed;text-decoration:line-through;}',
    '.au-qa-confirm{',
      'width:100%;padding:8px 12px;',
      'background:' + BRAND_NAVY + ';color:' + BRAND_MILK + ';',
      'font-family:' + FONT_BODY + ';font-size:11px;font-weight:600;',
      'letter-spacing:0.08em;text-transform:uppercase;',
      'border:none;cursor:pointer;transition:opacity .2s;',
    '}',
    '.au-qa-confirm:hover{opacity:0.85;}',
    '.au-qa-confirm:disabled{opacity:0.5;cursor:not-allowed;}',
    '.au-qa-msg{',
      'font-family:' + FONT_BODY + ';font-size:11px;color:' + BRAND_NAVY + ';',
      'text-align:center;margin-top:6px;min-height:14px;line-height:1.4;',
    '}',
  ].join('');
  document.head.appendChild(style);

  // ── Cart AJAX ──────────────────────────────────────────────────────────────
  function addToCart(variantId, btn, origText, msgEl) {
    btn.disabled = true;
    btn.textContent = 'Adding…';
    if (msgEl) msgEl.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      })
      .then(function (result) {
        if (!result.ok) {
          var errMsg = (result.body && result.body.description) || 'Could not add item';
          if (msgEl) msgEl.textContent = errMsg;
          btn.textContent = origText;
          btn.disabled = false;
          return;
        }
        btn.textContent = 'Added ✓';
        if (msgEl) msgEl.textContent = '';
        refreshCartCount();
        setTimeout(function () {
          btn.textContent = origText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        if (msgEl) msgEl.textContent = 'Network error — try again';
        btn.textContent = origText;
        btn.disabled = false;
      });
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        // Horizon / Dawn cart bubbles
        document.querySelectorAll(
          'cart-count-bubble, .cart-count-bubble, [data-cart-count], .header__cart-quantity, .cart__count'
        ).forEach(function (el) {
          if (el.tagName && el.tagName.toLowerCase() === 'cart-count-bubble') {
            var inner = el.querySelector('[aria-hidden]');
            if (inner) inner.textContent = count;
          } else {
            el.textContent = count;
          }
          el.removeAttribute('hidden');
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { count: count } }));
      })
      .catch(function () {});
  }

  // ── Per-card injection ─────────────────────────────────────────────────────
  function injectCard(card) {
    if (card.dataset.auQa) return;
    card.dataset.auQa = '1';

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];

    // Anchor: prefer .card__information but fall back to card itself
    var anchor = card.querySelector(
      '.card__information, .card__content .card__information, .product-item__info, .card-body'
    ) || card;

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product) return;
        var variants = product.variants || [];
        var availVariants = variants.filter(function (v) { return v.available; });
        if (!availVariants.length) return; // all out of stock

        var wrap = document.createElement('div');
        wrap.className = 'au-qa-wrap';

        if (variants.length === 1) {
          // ── Single variant — direct add ───────────────────────────────────
          var btn = document.createElement('button');
          btn.className = 'au-qa-btn';
          btn.textContent = 'Add to Cart';
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            addToCart(availVariants[0].id, btn, 'Add to Cart', null);
          });
          wrap.appendChild(btn);
        } else {
          // ── Multi-variant — size picker overlay ───────────────────────────
          var selectedId = null;

          var quickBtn = document.createElement('button');
          quickBtn.className = 'au-qa-btn';
          quickBtn.textContent = 'Quick Add';

          var overlay = document.createElement('div');
          overlay.className = 'au-qa-overlay';

          var overlayTitle = document.createElement('p');
          overlayTitle.className = 'au-qa-overlay-title';
          overlayTitle.textContent = 'Select size';

          var sizesDiv = document.createElement('div');
          sizesDiv.className = 'au-qa-sizes';

          variants.forEach(function (v) {
            var sz = document.createElement('button');
            sz.className = 'au-qa-size';
            sz.textContent = v.title;
            if (!v.available) {
              sz.disabled = true;
            } else {
              sz.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                sizesDiv.querySelectorAll('.au-qa-size').forEach(function (s) {
                  s.classList.remove('au-selected');
                });
                sz.classList.add('au-selected');
                selectedId = v.id;
              });
            }
            sizesDiv.appendChild(sz);
          });

          var confirmBtn = document.createElement('button');
          confirmBtn.className = 'au-qa-confirm';
          confirmBtn.textContent = 'Add to Cart';

          var msgEl = document.createElement('div');
          msgEl.className = 'au-qa-msg';

          confirmBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!selectedId) {
              msgEl.textContent = 'Select a size first';
              return;
            }
            addToCart(selectedId, confirmBtn, 'Add to Cart', msgEl);
          });

          overlay.appendChild(overlayTitle);
          overlay.appendChild(sizesDiv);
          overlay.appendChild(confirmBtn);
          overlay.appendChild(msgEl);

          quickBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var isOpen = overlay.classList.contains('is-open');
            // Close all other overlays first
            document.querySelectorAll('.au-qa-overlay.is-open').forEach(function (o) {
              o.classList.remove('is-open');
            });
            if (!isOpen) overlay.classList.add('is-open');
          });

          wrap.appendChild(quickBtn);
          wrap.appendChild(overlay);
        }

        anchor.appendChild(wrap);
      })
      .catch(function () {});
  }

  // Close overlays on outside click
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.au-qa-wrap')) {
      document.querySelectorAll('.au-qa-overlay.is-open').forEach(function (o) {
        o.classList.remove('is-open');
      });
    }
  });

  // ── DOM scan + MutationObserver for infinite scroll ───────────────────────
  var CARD_SEL = [
    '.card-wrapper',
    '.product-card',
    '[class*="product-item"]',
    'li.grid__item',
  ].join(', ');

  function scanCards() {
    document.querySelectorAll(CARD_SEL).forEach(injectCard);
  }

  var obs = new MutationObserver(function (mutations) {
    var needsScan = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { needsScan = true; break; }
    }
    if (needsScan) scanCards();
  });
  obs.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanCards);
  } else {
    scanCards();
  }
})();
